export function VenProLogo({ className = "", variant = "stacked" }) {
  const source = variant === "horizontal"
    ? "/brand/v2/venpro-horizontal-dark.svg"
    : "/brand/v2/venpro-stacked.svg";
  return <img className={className} src={source} alt="VenPro" />;
}
